<div #amountFormRef class="main-container onpage-popup">

  <!-- <div *ngIf="vars?.fundraiser?.is_multi_patient_campaign && (vars?.fundraiser?.is_multi_patient?.info_1 === '1') && vars?.pageName === 'campaign' && !isMobile" class="multi-patient-dropdown">
    <app-component-loader [load]="true" selector="app-multi-patient-dropdown" />
  </div> -->

  <div *ngIf="!isReward && !fixedAmount && (isMobile || config?.mostDonors) && !vars.selectedKCart && !vars.showStoryOnFundraiser" class="amount-btn text-center">
    <div class="approx">
      <p>Most Contributors contribute approx  <span><ng-template [ngTemplateOutlet]="currencyTemp"></ng-template>{{contributeDetails?.default_amount}}</span> to this Fundraiser</p>
    </div>
  </div>

  <app-quickdonate-card *ngIf="vwo.quickDonate_fallback_p1_AB() === 'v2' && isMobile" [currency]="currency"></app-quickdonate-card>

  <!-- <div *ngIf="vars?.fundraiser?.is_multi_patient_campaign && (vars?.fundraiser?.is_multi_patient?.info_1 === '0')" class="mb-3 d-none d-md-block d-lg-block">
    <app-multi-patient-note [theme]="'v2'" />
  </div> -->

  <div *ngIf="!fixedAmount && (!vars.selectedKCart || !isMobile)">

    <div *ngIf="vars.selectedKCart && !isMobile" class="extra-product-details">
      <app-component-loader [load]="true" selector="app-extra-product-details" />
    </div>

    <div *ngIf="payment_config?.enable_sip_switch" class="sip-switch">
      <app-otd-sip-toggle [payment_config]="payment_config"></app-otd-sip-toggle>
    </div>

    <div class="text-center" *ngIf="(!vars.selectedKCart || isMobile)">
      <app-slabs [params]="params" [currency]="currency" [contributeDetails]="contributeDetails" [isReward]="isReward"
                (amountChange)="setAmount($event)" [reward]="reward" (userSelectionCurrency)="setCurrency($event)"
                [type]="isSipCause?'sip_cause':''" [recommendTag]="recommendTag"
                [isQR]="isQR" [tagLabel]="tagLabel" [theme]="theme" [payment_config]="payment_config">
      </app-slabs>
    </div>
  </div>

  <!-- memorial check -->
  <div *ngIf="sipCause || contributeDetails?.ngo_sip_campaign" class="memorial-check">
    <mat-checkbox (change)="memorialSipCheck()" [(ngModel)]="isSipCause" color="primary">
      I agree to contribute on a monthly basis
    </mat-checkbox>
    <div *ngIf="memorialTooltip" class="memorial-tooltip">
      <i class="material-icons close" (click)="memorialTooltip=false">close</i>
      <div class="heading"><strong>Are you sure? </strong> Your contribution can help this family-</div>
      <div class="desc">
        <div class="list"><i class="material-icons">add_circle</i>Pay their financial debt</div>
        <div class="list"><i class="material-icons">check_circle</i>Seek essential medical aid</div>
        <div class="list"><i class="material-icons heart">favorite</i>Create a future for themselves</div>
      </div>
    </div>
  </div>

  <div *ngIf="!params?.sip_story && !isSipCause && !contributeDetails?.ngo_sip_campaign">
    <!-- All fundraisers, Stories except desktop and email coms users -->
    <div *ngIf="vars?.fundraiser?.tip_model || (vwo.kcart_tip_story_AB() && vars.showKCart) || (vars?.pageName?.match('stories|mini_story') && !params?.utm_source?.match('email') && isMobile) || (params?.utm_source?.match('internal_stories_otd_calling') && +params?.mini_story===1)" class="tip-card">
      <app-tip-card [currency]="currency"
                    [amount]="amount"
                    [baseAmount]="baseAmount"
                    (tipAmount)="setTipAmount($event)"
                    (lastTipAmtObj)="setLastTipAmt($event)"
                    (tipPercent)="setTipPercent($event)">
      </app-tip-card>
    </div>
  </div>

  <div *ngIf="vwo.otd_sip_AB()&& !vars.showKCart && isMobile && currency?.toLowerCase() !== 'inr' && !activeSips?.includes('medical') && params?.payment==='form'" class="sipPitch">
    <app-sip-pitch-otd [currency]="currency" (onSipCheck)="addSip($event)"/>
  </div>

  <div *ngIf="contributeDetails?.insurance" class="insurance-card">
    <app-insure-select [currency]="currency" [insureData]="contributeDetails?.insurance" (updateFamilyInsurance)="updateFamilyInsurance($event)" />
  </div>

  <form [formGroup]="amountForm" id="amountForm" (ngSubmit)="submitPayment()" [hidden]="!(!user || !inputFields || !user.phone_1) && !vars.isDummyEmail">
    <app-captcha-input (dataEmit)="captchaResponse($event)" *ngIf="enableCaptha" [control]="captcha" [type]="captchaType" size="invisible" [execute]="true" #captchaRef></app-captcha-input>
    <span *ngIf="config.only_inr && vars?.fundraiser?.disable_foreign_donation" class="accept-inr-donations"><i class="material-icons">info</i>This Fundraiser can only accept INR contributions!</span>
    <div class="wrap-input-field">
      <app-input inputType="text"
                [control]="name"
                [group]="amountForm"
                [placeHolder]="'Stories.donations.name.placeholder' | translatePipe | async"
                [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                icon="icon-user"
                [errorMessage]="'Stories.donations.name.error' | translatePipe | async"
                [isAnonymous]="is_anonymous?.value">
      </app-input>
      <mat-checkbox [hidden]="isSipStory || payment_config?.is_sip" class="anonymous-check" formControlName="is_anonymous" color="primary">
        {{('Stories.donations.donationAnonymous' | translatePipe | async)}}
      </mat-checkbox>
    </div>
    <app-input *ngIf="!vars.isAgent" inputType="email"
              [control]="email"
              [group]="amountForm"
              [placeHolder]="'Stories.donations.email.placeholder' | translatePipe | async"
              [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
              icon="icon-mail"
              [errorMessage]="'Stories.donations.email.error' | translatePipe | async">
    </app-input>
    <app-phone-number-input-v2
      *ngIf="!vars.isAgent"
      inputId="mobileInput"
      theme="material"
      [group]="amountForm"
      [control]="mobileControl"
      (onCountryChange)="setCountry($event)"
    />

    <!-- <app-module-loader [load]="amountForm?.controls['mobile']"
        selector="app-intl-input" moduleId="intl-input"
        [inputs]="{control: mobile, group: amountForm, placeholder: 'Stories.donations.phone' | translatePipe | async, validNoErr: 'Stories.donations.enterValidPhone' | translatePipe | async, showHint: true}">
    </app-module-loader> -->
    <!-- <app-intl-input *ngIf="amountForm?.controls['mobile']" [control]="mobile" [group]="amountForm"
                    [placeholder]="'Stories.donations.phone' | translatePipe | async"
                    [validNoErr]="'Stories.donations.enterValidPhone' | translatePipe | async" [showHint]="true">
    </app-intl-input> -->
    <!-- add another 100 on wallet section -->
    <div *ngIf="config.utm_nudge && paymentUtilService.utmProceedClicked">
      <app-utm-wallet-hundred type="form"></app-utm-wallet-hundred>
    </div>
    <app-input *ngIf="address && config.address" inputType="text"
              [control]="amountForm.controls['address']"
              [group]="amountForm"
              [placeHolder]="info.address.placeholder"
              icon="icon-city"
              [errorMessage]="info.address.error">
    </app-input>
    <app-input *ngIf="isPanCardExists && config?.pan"
              [control]="pancard"
              [group]="amountForm"
              [placeHolder]="info.pancard.placeholder"
              icon="icon-PAN"
              [errorMessage]="info.pancard.error">
    </app-input>
    <app-input *ngIf="askPassport && config?.passport"
              [control]="passport"
              [group]="amountForm"
              [placeHolder]="info.passport.placeholder"
              icon="icon-PAN"
              [errorMessage]="info.passport.error">
    </app-input>
    <app-input *ngIf="askPincode && config?.pincode"
              [control]="pincode"
              [group]="amountForm"
              [placeHolder]="info.pincode.placeholder"
              icon="icon-city"
              [errorMessage]="info.pincode.error">
    </app-input>
    <div *ngIf="config.nationality && contributeDetails.ask_citizenship" class="nationality"  [ngClass]="{ 'fmargin':origin === 'f', 'smargin': origin === 's'}">
      <mat-radio-group class="nationality-group" formControlName="nationality" [(ngModel)]="selectedNationality" (change)="nationalityChange()">
        <mat-radio-button class="nationality-radio-btn"  [value]="true">I’m an Indian National</mat-radio-button>
        <mat-radio-button class="nationality-radio-btn"  [value]="'0'">I’m not an Indian National</mat-radio-button>
      </mat-radio-group>
      <small class="error-message" *ngIf="nationality.invalid && nationality.touched">This field is required</small>
    </div>

    <div *ngIf="vars.pageName.match('stories') && !isMobile && vwo.tip_desktop_story_AB()" class="tip-desktop">
      <app-tip-select-nudge
        [currency]="currency"
        [amount]="amount"
        [baseAmount]="baseAmount"
        [selectedTipPerc]="vwo.tip_desktop_story_AB()"
        (setTipAmount)="setTipAmount($event)"
        (setLastTipAmt)="setLastTipAmt($event)"
        (setTipPercent)="setTipPercent($event)"
      />
    </div>

    <div *ngIf="(vars.pageName === 'stories' || vars.showStoryOnFundraiser) && vars?.fundraiser?.beneficiary?.tax_benefit && !params.mini_story && currency === 'INR' && !(vars.pageName.match('stories') && !isMobile && vwo.tip_desktop_story_AB())" class="tax_nudge">
      <i class="material-icons">info</i>
      <div class="nudge_text">For tax benefits, update your PAN and address under profile details after completing your contribution.</div>
    </div>

    <div class="text-center proceed-btn" *ngIf="!((showBulkDonationFor.test(params?.utm_medium) || vars.showKCart) && vars.pageName === 'stories' && isMobile) && !(vars.pageName === 'mini_story' && vars.showBulkDonationForMiniStory.test(params?.utm_source))">
      <div class="tipDistribution" *ngIf="fromToggleTip">
        Contribution : <app-currency-icon [currency] = "currency" ></app-currency-icon>{{amount - tipAmount}}   +   Tip : <app-currency-icon [currency] = "currency" ></app-currency-icon>{{tipAmount}}
      </div>
      <app-donate-btn id="formSubmit" class="app-button" [btnClass]="'contri-initiate-btn donation-form-submit'" type="submit"
                      [miniStory]="miniStory" [label]="params?.sip_story ? 'Pledge' : (config.donate_label | translatePipe | async)" [isOrderLoading]="isLoading || vars.isOrderLoading" [amount]="amount"
                      [type]="paymentUtilService.paymentMode" [isSipCause]="isSipCause" [ngo_Sip]="ngo_sip" [payment_config]="payment_config" [month_interval]="month_interval" [fundraiser]="vars?.fundraiser"
                      [hideAmount]="false">
      </app-donate-btn>
    </div>

    <div class="text-center proceed-btn" *ngIf="(showBulkDonationFor.test(params?.utm_medium) || vars.showKCart) && vars.pageName === 'stories' && isMobile">
      <app-bulk-donation-selection
        [campaign_id]="campaignId"
        [amount]="amount"
        [disabled]="amountForm.invalid"
        [currency]="currency"
        [isOrderLoading]="isLoading"
        (onSubmit)="submitBulk($event)"
      />
    </div>

    <div *ngIf="vars.pageName === 'mini_story' && vars.showBulkDonationForMiniStory.test(params?.utm_source)" class="bulk-selection text-center proceed-btn">
      <app-bulk-donation-selection-v2
        [amount]="amount"
        [campaign_id]="campaignId"
        [currency]="currency"
        [disabled]="amountForm.invalid"
        [isOrderLoading]="isLoading"
        (onSubmit)="submitBulk($event)"
      />
    </div>

  </form>

  <div [hidden]="!(user && inputFields) || (user && !user?.phone_1) || vars.isDummyEmail">
    <app-user-info
      [amount]="amount"
      [campaignId]="campaignId"
      [currency]="currency"
      [isLoading]="isLoading"
      [config]="config"
      [user]="user"
      [disabled]="amountForm.invalid"
      [payment_config]="payment_config"
      [isAnonymous]="contributeDetails?.anonymous"
      (onBtnClick)="submitPayment()"
      (onSubmitBulk)="submitBulk($event)"
      (isAnonymousChange)="isAnonymousChange($event)"
      (onEditClick)="inputFields=!$event">
    </app-user-info>
  </div>

  <div *ngIf="paymentIcons" class="payment-gateways">
    <div class="safekey"></div>
    <div class="visa"></div>
    <div class="mastercard"></div>
    <div class="stripe"></div>
  </div>
  <div class="sms-promo" *ngIf="vars?.fundraiser?.id === 190929 || vars?.fundraiser?.id === 57877">
    <mat-checkbox color="primary">
      <span style="color:#888888">I agree to receive SMS from Ketto. Messaging and <br> Data fees may apply. Reply STOP to unsubscribe.</span>
    </mat-checkbox>
  </div>
  <div *ngIf="!vars.thirdPartyApp && this.params?.entity_type !== 'ngo'" class="tnc">
    <p>{{'Stories.donations.termsconditionsStatement1' | translatePipe | async}}
        <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1" target="_blank">{{'Stories.donations.termsService' | translatePipe | async}}</a> {{'Stories.donations.and' | translatePipe | async}}
        <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021" target="_blank">{{'Stories.donations.privacyPolicy' | translatePipe | async}}</a>
        {{'Stories.donations.termsconditionsStatement2' | translatePipe | async}}
    </p>
  </div>

  <div *ngIf="false" class="captcha-note">
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
  </div>
</div>

<!-- Currecny display template -->
<ng-template #currencyTemp>
  <i class="icon" *ngIf="currencyDetails?.is_symbol" [ngClass]="currencyDetails?.icon"></i>
  <span *ngIf="!currencyDetails?.is_symbol" [innerHTML]="currencyDetails?.symbol"></span>
</ng-template>


<!-- Proceed to login popup -->
<ng-template #paytmLoginRef>
  <div class="paytm-consent">
    <p>Login is mandatory to proceed</p>
    <div class="actions">
      <button (click)="paytmLoginConsent(); dialogRef.close();" mat-stroked-button>OK</button>
      <button (click)="exitPaytm()" class="exit" mat-button>Exit</button>
    </div>
  </div>
</ng-template>
